// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-default.section-default--gtv-videoloop .video-box{display:block;padding:0 20px;position:relative;width:100%}@media screen and (min-width:1110px){.section-default.section-default--gtv-videoloop .video-box{padding:0}}.section-default.section-default--gtv-videoloop .video-box video{display:block;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
